import { createSlice } from '@reduxjs/toolkit';

const successRate = {
  code: 200,
  data: {
    apCount: 3,
    total: 1800,
    success: 91,
    P95ms: 1200,
    pingPongCount: 0,
    threshold: 2000,
    series: [
      ['0-50', 250],
      ['50-200', 550],
      ['200-2000', 350],
      ['2000-', 100],
    ],
  },
};

const pairStats = {
  code: 200,
  data: {
    data: [
      {
        fromDeviceName: 'AP-Lobby-Main',
        fromDeviceId: '3f1c2a7e-9d4b-4f3a-8c21-6d9e5b2a1c44',
        toDeviceName: 'AP-Elevator-Bank-01',
        toDeviceId: 'a8d91f2c-3b7e-4c91-9f3a-1d2e8c6b5a77',
        events: 342,
        P95ms: 18400,
        failRatePercent: 24.5,
      },
      {
        fromDeviceName: 'AP-Warehouse-Zone-C',
        fromDeviceId: '6c4f9a21-8e3b-4d5c-9a1f-7b2d3e8c91f0',
        toDeviceName: 'AP-Loading-Dock',
        toDeviceId: '1b7e9c3a-5f2d-4a88-9c6e-3d1f7a2b8e44',
        events: 105,
        P95ms: 12200,
        failRatePercent: 15.8,
      },
      {
        fromDeviceName: 'AP-Conf-Room-402',
        fromDeviceId: 'd9a3f1c8-2e7b-4c91-8a5d-6f3b1c9e2a10',
        toDeviceName: 'AP-Hallway-West',
        toDeviceId: '4e2b8c91-7a3d-4f6c-9b1e-5d8a2c3f7e99',
        events: 890,
        P95ms: 9500,
        failRatePercent: 11.2,
      },
      {
        fromDeviceName: 'AP-Parking-Level-B1',
        fromDeviceId: '8a1d6f3c-9b2e-4c71-a5f9-3e8b1d2c6a44',
        toDeviceName: 'AP-Stairwell-B',
        toDeviceId: '2c9f1a7b-6d3e-4b81-9c5a-7f1e8d2b3c66',
        events: 156,
        P95ms: 7800,
        failRatePercent: 8.4,
      },
      {
        fromDeviceName: 'AP-Office-North-05',
        fromDeviceId: 'f1a8c3d2-5b7e-4c91-8d6a-2e9f1b3c7a55',
        toDeviceName: 'AP-Pantry-Area',
        toDeviceId: '7d3a9f2c-1e8b-4c6d-9a4f-5b2c8e1d7f33',
        events: 450,
        P95ms: 5200,
        failRatePercent: 4.1,
      },
    ],
  },
};

const ssidStats = {
  code: 200,
  data: {
    data: [
      {
        ssid: 'Corp_Internal_WPA3',
        events: 1450,
        P95ms: 1200,
        successRatePercent: 98.2,
      },
      {
        ssid: 'Guest_Portal_Web',
        events: 820,
        P95ms: 14800,
        successRatePercent: 98.2,
      },
      {
        ssid: 'Warehouse_Scanner_Legacy',
        events: 105,
        P95ms: 22500,
        successRatePercent: 72.1,
      },
    ],
  },
};

const initialState = {
  successRate,
  pairStats,
  ssidStats,
};

export const ainsightRoamSlice = createSlice({
  name: 'aInsightRoam',
  initialState,
  reducers: {},
});

export default ainsightRoamSlice.reducer;
